import { u, styled } from '../../../../shared/theming-sc'

const SaveButton = styled.a`
    padding: ${u.getSpacing('small')}px ${u.getSpacing('large')}px;
    background-color: ${u.getColor('accent1')};
    color: white;
    position: relative;
    display: inline-block;
    top: -${u.getSpacing('small')}px;
    margin-top: ${u.getSpacing('small')}px;
    border-radius: 5px;

    &:hover {
        background-color: ${u.getColor('accent1Dark')};
        color: white !important;
    }
`

const SaveControlsWrapper = styled.div`
    width: 100%;
    clear: both;
    text-align: center;
    margin-bottom: ${u.getSpacing('large')}px;
`

const SaveInput = styled.input`
    position: relative;
    border: solid 1px ${u.getColor('greyMuted')};
    background-color: white;
    border-radius: 5px;
    padding: ${u.getSpacing('small')}px;
    color: ${u.getColor('greyDark')};
    font-size: ${u.getFontSize('md')};
    width: 100%;
    margin: ${u.getSpacing('small')}px 0;
`

const SaveFilterErrorWrapper = styled.div`
    display: block;
    margin-top: ${u.getSpacing('small')}px;
    margin-bottom: ${u.getSpacing('small')}px;

    svg {
        path {
            stroke: ${u.getColor('primary')};
        }
    }
`

export {
  SaveInput,
  SaveButton,
  SaveControlsWrapper,
  SaveFilterErrorWrapper
}
